import { render } from "./TheImage.vue?vue&type=template&id=2f2fd52c&scoped=true"
import script from "./TheImage.vue?vue&type=script&lang=js"
export * from "./TheImage.vue?vue&type=script&lang=js"

import "./TheImage.vue?vue&type=style&index=0&id=2f2fd52c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2fd52c"]])

export default __exports__